import { useOrgMembers } from "./useOrgMembers";
import { Card, CardContent } from "@/components/ui/card";
import { User, Shield, Crown } from "lucide-react";

const ROLE_CONFIG: Record<
  string,
  { icon: React.ComponentType<{ className?: string }>; label: string; color: string }
> = {
  owner: { icon: Crown, label: "Owner", color: "#d97706" },
  admin: { icon: Shield, label: "Admin", color: "#2563eb" },
  member: { icon: User, label: "Member", color: "#6b7280" },
};

export function OrgMembersList() {
  const { data, isPending, error } = useOrgMembers();

  if (isPending) {
    return (
      <div className="text-sm text-muted-foreground py-4">
        Loading members…
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-sm text-red-600 py-4">
        Unable to load members. The org_members table may not exist yet.
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="text-sm text-muted-foreground py-4">
        No members found. You are the only user in this organization.
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {data.map((member) => {
        const config = ROLE_CONFIG[member.role] || ROLE_CONFIG.member;
        const Icon = config.icon;
        return (
          <Card key={member.id}>
            <CardContent className="p-3 flex items-center gap-3">
              <div
                className="flex items-center justify-center w-8 h-8 rounded-full shrink-0"
                style={{ backgroundColor: `${config.color}15` }}
              >
                <Icon
                  className="w-4 h-4"
                  style={{ color: config.color }}
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium truncate">
                  {member.display_name || member.email || "Unknown user"}
                </p>
                {member.email && member.display_name && (
                  <p className="text-xs text-muted-foreground truncate">
                    {member.email}
                  </p>
                )}
              </div>
              <span
                className="text-xs font-medium px-2 py-0.5 rounded-full shrink-0"
                style={{
                  backgroundColor: `${config.color}15`,
                  color: config.color,
                }}
              >
                {config.label}
              </span>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
